import React from 'react';
import styled from 'styled-components';
import { extractSuffix, ADDITIONAL_FIELDS } from 'helpers/DocumentTemplateHelper';
import { getTranslatedString } from 'helpers/i18n';

const LeaseSummaryColumn = styled.div`
  width: 100%;
  float: left;
`;

const LeaseSummaryColumnTitle = styled.div`
  font-style: normal;
  font-weight: bold;
  font-size: 1.2rem;
  line-height: 22px;
`;

const LeaseSummaryColumnContent = styled.div`
  font-style: normal;
  font-weight: normal;
  font-size: 1.2rem;
  margin: 3px 0 8px 0;
`;

export default function AdditionalInformation({ leaseDetails }) {
  return (
    <div>
      {leaseDetails.draft_lease_data.additional_fields &&
        leaseDetails.draft_lease_data.additional_fields.map((field, index) => {
          const label = extractSuffix(field.label, ADDITIONAL_FIELDS);
          let value = field.default_value;
          if (field.field_type === 'checkbox') {
            value =
              field.default_value.toString() === 'true'
                ? getTranslatedString('yes')
                : getTranslatedString('no');
          }
          return (
            <LeaseSummaryColumn key={`additional_info_${index}`}>
              <LeaseSummaryColumnTitle>{label}</LeaseSummaryColumnTitle>
              <LeaseSummaryColumnContent>{value}</LeaseSummaryColumnContent>
            </LeaseSummaryColumn>
          );
        })}
    </div>
  );
}
